module.exports = __webpack_public_path__ + "img/2c4a8ef.png";